/* eslint-disable no-case-declarations */
/*
 * @Author: 张志明
 * @Date: 2023-02-17 10:09:00
 * @LastEditTime: 2024-04-19 16:14:07
 * @Description:
 */
import pluginVideo from './../compontents/video.vue';
export default {
    components: { pluginVideo },
    data() {
        return {
            time: 1,
            pluginInstall: false,
        };
    },
    created() {},
    computed: {},
    mounted() {
        this.checkPluginState().then((install) => {
            this.pluginInstall = install;
        });
    },
    methods: {
        //轮询次数
        checkPluginState(pollTime = 5) {
            let that = this;
            this.time = 1;
            return new Promise((resolve) => {
                let loopFun = () => {
                    //验证是否安装插件 500毫秒轮询1次
                    if (that.time > pollTime) {
                        resolve(false);
                        return;
                    }
                    setTimeout(() => {
                        that.time += 1;
                        if (Object.prototype.hasOwnProperty.call(window, 'dsToolsPlugin')) {
                            resolve(true);
                        } else {
                            loopFun();
                        }
                    }, 300);
                };
                loopFun();
            });
        },
        checkPluginInstall(pollTime = 2) {
            let that = this;
            return new Promise((resolve) => {
                this.checkPluginState(pollTime).then((install) => {
                    if (install) {
                        resolve(true);
                    } else {
                        this.$nextTick(() => {
                            that.$refs.pluginVideo.show();
                        });
                        // this.$confirm('店铺诊断，请先安装插件!', '提示', {
                        //     confirmButtonText: '下载插件',
                        //     showCancelButton: false,
                        //     type: 'warning',
                        // })
                        //     .then(() => {
                        //         window.open(
                        //             'https://oss.fjdaze.com/tools/aliToolsPlugins/integrated-plugin/integrated-plugin.zip'
                        //         );
                        //     })
                        //     .catch(() => {});
                        resolve(false);
                    }
                });
            });
            //验证插件登录
        },
        check1688Login() {
            return new Promise((resolve) => {
                window.dsToolsPlugin
                    .getLoginUid()
                    .then(({ uid1688 }) => {
                        if (uid1688 && uid1688.indexOf(this.$store.state.info.memberInfo.Account) > -1) {
                            resolve(true);
                            return;
                        }
                        this.$confirm('抱歉，你当前的店铺未登录1688的账号，请确认登录后再诊断', '提示', {
                            confirmButtonText: '去登录',
                            cancelButtonText: '取消',
                            type: 'warning',
                        })
                            .then(() => {
                                window.open(
                                    'https://login.taobao.com/?redirect_url=https%3A%2F%2Flogin.1688.com%2Fmember%2Fjump.htm%3Ftarget%3Dhttps%253A%252F%252Flogin.1688.com%252Fmember%252FmarketSigninJump.htm%253FDone%253D%25252F%25252Fmy.1688.com%25252F&style=tao_custom&from=1688web'
                                );
                            })
                            .catch(() => {});
                        resolve(false);
                    })
                    .catch((error) => {
                        if (error.includes('Extension context invalidated')) {
                            this.$confirm('检测到您未安装插件或已安装未刷新页面，请确认后再试', '提示', {
                                confirmButtonText: '下载插件',
                                cancelButtonText: '忽略',
                                showCancelButton: false,
                                showClose: false,
                                type: 'warning',
                            })
                                .then(() => {
                                    window.open(
                                        'https://oss.fjdaze.com/tools/aliToolsPlugins/integrated-plugin/integrated-plugin.zip'
                                    );
                                })
                                .catch(() => {});
                        }
                        resolve(false);
                    });
            });
        },
    },
};
